"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_service_1 = require("../../shared/resource.service");
var environment_1 = require("../../../environments/environment");
var driver_reference_serializer_1 = require("./driver-reference.serializer");
var http_1 = require("@angular/http");
var DriverReferenceService = /** @class */ (function (_super) {
    __extends(DriverReferenceService, _super);
    function DriverReferenceService(http) {
        var _this = _super.call(this, http, 'reference/drivers/', new driver_reference_serializer_1.DriverReferenceSerializer()) || this;
        _this.baseUrl = environment_1.environment.serverUrl + 'reference/drivers/';
        _this.allSelected = false;
        return _this;
    }
    return DriverReferenceService;
}(resource_service_1.ResourceService));
exports.DriverReferenceService = DriverReferenceService;
